(function(){
    'use strict'; 
    angular.module('app').controller('CreateCaseModalController', CreateCaseModalController);
    CreateCaseModalController.$inject = [
        'CasesTable',
        '$timeout',
        '$uibModalInstance',
        'AccountingService',
        'toastr',
        'shipment',
        'cases'
    ]; 

    function CreateCaseModalController(
        CasesTable,
        $timeout,
        $uibModalInstance,
        AccountingService,
        toastr,
        shipment,
        cases
    ){
        const vm = this; 

        vm.close = close; 
        vm.createCase = createCase;

        init();
        function init() {
            $timeout(()=>{
                initializeCasesTable();
            }, 100);
        }

        function initializeCasesTable(){
            console.log(cases);
            vm.casesTableService = new CasesTable({cases: [], form: vm.casesTableForm});
            vm.casesTableData = vm.casesTableService.tableData;
        }

        function createCase(){
            const cases = vm.casesTableService.getApiPayload(); 
            if(cases.length > 0) {
                AccountingService.CaseManagement.createCase(success => {
                    toastr.success("Cases as been created", "Success");
                    $uibModalInstance.dismiss();
                }, error => {
                    toastr.error(error.message, "Error");
                    $uibModalInstance.dismiss();
                }, {
                    cases: cases, 
                    shipmentId: shipment.id
                });
            }
        }

        function close(){
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/modals/CreateCaseModalController.js